import { SET_SELECTED_ROOM_ICON } from 'actions';
import { IRoomIcon } from 'typings';

export function setSelectedRoomIcon(selectedRoomIcon?: IRoomIcon) {
  return { selectedRoomIcon, type: SET_SELECTED_ROOM_ICON };
}
